import React, { useEffect, useRef, useState } from "react";
import { isSolidColorImage } from "../Services/helper";

const ScrollerStruct = ({ children, terminalData, className }) => {
  const scrollListingRef = useRef(null);

  const scrollListingLeft = () => {
    if (scrollListingRef.current) {
      scrollListingRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollListingRight = () => {
    if (scrollListingRef.current) {
      scrollListingRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <>
      <button
        onClick={scrollListingLeft}
        className="absolute left-2 top-1/2  z-20 -translate-y-1/2 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700"
      >
        ❮
      </button>

      <div ref={scrollListingRef} className={className}>
        {children}
      </div>

      <button
        onClick={scrollListingRight}
        className="absolute right-2 top-1/2 z-20  -translate-y-1/2 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700"
      >
        ❯
      </button>
    </>
  );
};

export const QrCodes = ({ qrCodes, qrCodeLabel }) => {
  const scrollListingRef = useRef(null);
  const scrollListingLeft = () => {
    if (scrollListingRef.current) {
      scrollListingRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };
  const scrollListingRight = () => {
    if (scrollListingRef.current) {
      scrollListingRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };
  return (
    <div className="px-5  py-1 mt-0 mb-0 flex flex-col">
      <div className="relative w-full h-fit">
        <button
          onClick={scrollListingLeft}
          className="absolute left-2 top-1/2  z-20 -translate-y-1/2 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700"
        >
          ❮
        </button>
        <div
          ref={scrollListingRef}
          className="relative place-items-center h-full mb-0 flex gap-4 overflow-x-auto whitespace-nowrap scrollbar-hide px-4"
        >
          {qrCodes?.map((qr, idx) => (
            <div
              key={idx}
              className={`relative w-full max-w-[202rem] 
          sm:w-[24rem] 
          md:w-[20rem] 
          lg:w-[18rem] 
          xl:w-[18rem] 
          2xl:w-[20rem] h-56 rounded-lg shadow-lg hover:shadow-xl transition bg-cover bg-center`}
              style={{
                backgroundImage: `url(${qr.backgroundImageUrl})`,
                backgroundColor: qr.backgroundColor,
              }}
            >
              <div className="absolute inset-0 bg-black/40 rounded-lg z-0" />
              <div
                className="flex flex-col justify-between h-full max-w-[202rem] 
          sm:w-[24rem] 
          md:w-[20rem] 
          lg:w-[18rem] 
          xl:w-[18rem] 
          2xl:w-[20rem] h-56 relative z-10"
              >
                <h3 className="text-center text-black bg-white/70 p-2 text-2xl 3xl:text-[4rem] font-semibold w-fit mt-4 min-w-[50%] rounded -[5px]">
                  {qr.title}
                </h3>
                <div
                  className="self-end w-32 h-32 bg-white  rounded-lg mt-2 bg-contain bg-center"
                  style={{
                    backgroundImage: `url(${qr.imageUrl})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <button
          onClick={scrollListingRight}
          className="absolute right-2 top-1/2 z-20  -translate-y-1/2 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700"
        >
          ❯
        </button>
      </div>
    </div>
  );
};

const DisplayService = ({ setSelectedService, service,serviceId,setIsMap }) => {
  const [showBg, setShowBg] = useState(true);
  useEffect(() => {
    (async () => {
      const res = await isSolidColorImage(service.imageUrl,90);
      if (res?.isSolidColor) {
        setShowBg(false);
      }
    })();
  }, [service.imageUrl]);

  return (
    <div
      className={` 
        w-full max-w-[202rem] 
        sm:w-[24rem] 
        md:w-[20rem] 
        lg:w-[18rem] 
        xl:w-[18rem] 
        2xl:w-[20rem] h-56
        relative bg-cover bg-no-repeat bg-center rounded-lg shadow-lg hover:shadow-xl transition
      ${service?.serviceType==="Points of Interests"||serviceId===4?'cursor-pointer':'cursor-default'}
        `}
      style={{
        backgroundImage: `url(${service.imageUrl})`,
      }}
      onClick={() => {
        setSelectedService(service.link);
        setIsMap(service?.serviceType==="Points of Interests"||service?.serviceTypeId===4);
      }}
    >
      {showBg && (
        <div className="absolute inset-0 bg-black/40 rounded-lg z-0" />
      )}
      <div
        className={`flex items-center justify-center h-full relative z-10 w-full max-w-[202rem] 
          sm:w-[24rem] 
          md:w-[20rem] 
          lg:w-[18rem] 
          xl:w-[18rem] 
          2xl:w-[20rem] h-56`}
      >
        <h3 className="text-center text-white bg-black/50 p-2 text-2xl 3xl:text-[4rem] font-semibold align-center items-center w-fit min-w-[70%] px-2 rounded-md">
          {service.title}
        </h3>
      </div>
    </div>
  );
};

export const ServicesHorizontal = ({
  setSelectedService,
  services,
  serviceLabel,
  setIsMap

}) => {

  return (
    <div className="px-5  py-1 mt-0 flex flex-col mb-8">
      <div className="relative w-full h-fit">
       
        <ScrollerStruct
          className="relative place-items-center h-full mb-0 flex gap-4 overflow-x-auto whitespace-nowrap scrollbar-hide px-4"
        >
          {services?.map((service, idx) => (
            <DisplayService 
            key={idx}
            setSelectedService={setSelectedService}
            service={service}
            serviceId={service?.serviceTypeId}
            setIsMap={setIsMap}
            />
          ))}
        </ScrollerStruct>
       
      </div>
    </div>
  );
};